export default {
    props: {
        model: {
            type: [Array, Object]
        },

        height: {
            type: String, 
            default: '350px'
        }
    },

    data () {
        return {
            chartRef: undefined
        }
    },

    computed: {
        chartHeight() {
            return `${this.height}px`;
        }
    },

    watch: {
        model (value) {
            if (this.chartRef) {
                this.redraw(this.chartRef)
            }
        }
    },

    methods: {
        redraw (chart) {
            d3.select(this.$refs.chart)
            .datum(this.model)
            .transition()
            .duration(500)
            .style('height', this.height)
            .call(chart);
        }
    }
}
